// extracted by mini-css-extract-plugin
module.exports = {"searchHorizontalRecosContainer":"UQ","reco":"VQ","products":"WQ"};